import styles from '@/components/agents/agents.module.css';

import clsxm from '@/lib/clsxm';

import { delay, SectionHeading, tone } from '@/components/agents/primitives';
import { useReveal } from '@/components/agents/useReveal';

import { COOKIE_DAYS } from './kit';

const STEPS = [
  {
    title: 'Join for free',
    text: 'Sign up in a minute on our affiliate portal. You don’t need to be a customer first.',
  },
  {
    title: 'Share your link',
    text: `Post your unique link on your website, blog, social media or with your clients. A visit counts for ${COOKIE_DAYS} days after the last click.`,
  },
  {
    title: 'Get paid every month',
    text: 'You earn 30% of every payment your referrals make. Commissions go to your PayPal in the first week of each month once your balance reaches US$50. Smaller balances carry forward.',
  },
];

export default function AffiliatesSteps() {
  const { ref, state } = useReveal<HTMLOListElement>(0.2);

  return (
    <section id='how-it-works' className='scroll-mt-8 py-24 sm:py-32'>
      <div className='mx-auto max-w-7xl px-6 lg:px-8'>
        <SectionHeading
          title='How it works.'
          tail='Three steps, then it runs on its own.'
        />
        <ol
          ref={ref}
          data-reveal={state}
          className={clsxm(styles.reveal, 'mt-14 grid gap-4 md:grid-cols-3')}
        >
          {STEPS.map(({ title, text }, index) => (
            <li
              key={title}
              className={clsxm(
                styles.rv,
                'rounded-[22px] p-7',
                tone.surface,
                tone.line,
              )}
              style={delay(index * 90)}
            >
              <span className='flex h-9 w-9 items-center justify-center rounded-full bg-primary-50 text-sm font-semibold tabular-nums text-primary-700 dark:bg-primary-500/15 dark:text-primary-300'>
                {index + 1}
              </span>
              <h3
                className={clsxm(
                  'mt-5 text-xl font-semibold tracking-[-0.015em]',
                  tone.ink,
                )}
              >
                {title}
              </h3>
              <p className={clsxm('mt-2 text-[15px] leading-7', tone.body)}>
                {text}
              </p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
